<template>
  <div class="pt-3">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header border-bottom p-2">
              <div class="btn-group btn-group-toggle" data-toggle="buttons">
                <button
                  class="btn btn-primary btn-sm"
                  :class="{ active: selectedView === 'received' }"
                  @click="selectedView = 'received'"
                >
                  Pagos recibidos
                </button>
                <button
                  class="btn btn-primary btn-sm"
                  :class="{ active: selectedView === 'pending' }"
                  @click="selectedView = 'pending'"
                >
                  Pendientes por pagar
                </button>
                <button
                  class="btn btn-primary btn-sm"
                  :class="{ active: selectedView === 'approved' }"
                  @click="selectedView = 'approved'"
                >
                  Pagos verificados
                </button>
                <button
                  class="btn btn-primary btn-sm"
                  :class="{ active: selectedView === 'rejected' }"
                  @click="selectedView = 'rejected'"
                >
                  Pagos Rechazados
                </button>
                <button
                  class="btn btn-primary btn-sm"
                  :class="{ active: selectedView === 'collection' }"
                  @click="selectedView = 'collection'"
                >
                  Cobros generados
                </button>
              </div>
            </div>
            <div class="card-body">
              <!-- Conditionally render the components based on the selected view -->
              <monthly-payments-received v-if="selectedView === 'received'" />
              <pending-payments v-if="selectedView === 'pending'" />
              <collection v-if="selectedView === 'collection'" />
              <approved-payments v-if="selectedView === 'approved'" />
              <rejected-payments v-if="selectedView === 'rejected'" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Collection from './Collection.vue'
import MonthlyPaymentsReceived from './MonthlyPaymentsReceived.vue'
import PendingPayments from './PendingPayments.vue'
import ApprovedPayments from './ApprovedPayments.vue'
import RejectedPayments from './RejectedPayments.vue'

export default {
  data() {
    return {
      selectedView: 'received' // Default view
    }
  },
  components: {
    Collection,
    MonthlyPaymentsReceived,
    PendingPayments,
    ApprovedPayments,
    RejectedPayments
  }
}
</script>

<style></style>
